import React from "react";
import "./ambassadorEarnings.scss";

// Dummy data for the levels (icon paths, names, rates)
const LEVELS_DATA = [
  { name: "Star", rate: 1.0, icon: "/starlevel.svg" },
  { name: "Silver", rate: 1.25, icon: "/silverlevel.svg" },
  { name: "Gold", rate: 1.5, icon: "/goldlevel.svg" },
  { name: "Platinum", rate: 1.75, icon: "/platinumlevel.svg" },
  { name: "Black Diamond", rate: 2.0, icon: "/diamondlevel.svg" },
];

const AmbassadorEarnings = () => {
  return (
    <div className="ambassador-earnings-container">
      <h3>Daily Reward Earning Rates</h3>
      <ul className="earnings-list">
        {LEVELS_DATA.map((lvl, idx) => (
          <li key={idx} className="earnings-item">
            <img src={lvl.icon} alt={lvl.name} className="earnings-icon" />
            <div className="earnings-text">
              <span className="earnings-level-name">{lvl.name}</span>
              <span className="earnings-rate">
                ${lvl.rate.toFixed(2)} per signup
              </span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AmbassadorEarnings;
